import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { priceMemoMaintenanceDataEndpoint } from '../../../common/endpoints';

export const fetchPriceMemoMaintenanceData = createApi(priceMemoMaintenanceDataEndpoint, 'GET');

const PriceMemoMaintenance = createSlice({
  name: 'PriceMemoMaintenance',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPriceMemoMaintenanceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPriceMemoMaintenanceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPriceMemoMaintenanceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PriceMemoMaintenance.reducer;